<template lang="pug">
  button.c-btn.c-btn--add-to-cart.u-mrs(@click='onAddToCartFromTomPremiumSummary', type='button', class=(!isMobile) ? 'c-btn--lg' : 'c-btn--lg c-btn--fill')
    | Great! Add to Cart
</template>

<script>
export default {
  methods: {
    onAddToCartFromTomPremiumSummary() {
      return this.$store.dispatch('addToCartFromPremumSummaryTrigger');
    }
  }
};
</script>
